/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["html[_ngcontent-%COMP%] {\n  min-height: 100vh; }\n\n.content-container[_ngcontent-%COMP%] {\n  min-height: 100vh;\n  background: -webkit-gradient(linear, left top, left bottom, from(#043169), color-stop(30%, #043169), color-stop(30%, #043169), color-stop(30%, var(--cust-bg)), to(var(--cust-bg)));\n  background: linear-gradient(to bottom, #043169 0%, #043169 30%, #043169 30%, var(--cust-bg) 30%, var(--cust-bg) 100%);\n  background-size: cover; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/news/news.component.scss.shim.ngstyle.js.pre-build-optimizer.js